import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import { DangerouslySetHtmlContent } from 'iovisit-theme/components';

const messages = defineMessages({
  booking_button_label: {
    id: 'Book now',
    defaultMessage: 'Prenota ora!',
  },
});

interface BookingProps {
  content: object;
}

export const hasBooking = (content) => {
  return (
    content.booking_button_url ||
    content.booking_email_address ||
    content.booking_embed_html ||
    content.booking_box_description
  );
};

const Booking: React.FC<BookingProps> = ({ content }) => {
  const intl = useIntl();

  if (!hasBooking(content)) {
    return null;
  }
  const description = content.booking_box_description;
  const url_label =
    content.booking_button_label ??
    intl.formatMessage(messages.booking_button_label);
  const mail_address =
    content?.booking_email_address &&
    content.booking_email_address.replace('mailto:', '');

  let link = (
    <UniversalLink
      href={mail_address || content.booking_button_url}
      className="ui button primary"
    >
      {url_label}
    </UniversalLink>
  );
  if (content.booking_embed_html) {
    link = (
      <DangerouslySetHtmlContent
        html={content.booking_embed_html}
        className="embed-html"
      />
    );
  }

  return (
    <div className="booking">
      {description && <div className="booking-text">{description}</div>}
      {(mail_address ||
        content.booking_button_url ||
        content.booking_embed_html) && (
        <div className="booking-link">{link}</div>
      )}
    </div>
  );
};

export default Booking;
